module.exports = __webpack_public_path__ + "img/legal-documents.50d73c7e.png";